// © 2025 Camp Promethean, LLC. All Rights Reserved.

export function ChemicalCalculatorTooltipContent() {
  return (
    <div className="space-y-2.5 text-xs leading-relaxed">
      <p className="text-sm font-medium">Chemical Calculator</p>
      <p>
        Scales field label rates down to small tank mixes. Enter the product rate from the label
        and your tank size to get the amount to add in mL.
      </p>
      <div>
        <p className="font-medium">How to use</p>
        <ol className="mt-1 list-decimal space-y-0.5 pl-4">
          <li>Enter the label rate and select its unit (L/acre, gal/acre, oz/100 gal, etc.).</li>
          <li>Enter your tank size in gallons or liters.</li>
          <li>Read the calculated product amount — it updates as you type.</li>
        </ol>
      </div>
      <div>
        <p className="font-medium">Also includes</p>
        <ul className="mt-1 list-disc space-y-0.5 pl-4">
          <li>Recommended mixing order for tank batches</li>
          <li>Safety reminders for PPE, compatibility, and label limits</li>
        </ul>
      </div>
      <p className="text-muted-foreground">
        Always follow the product label — this tool assists with math, not regulatory guidance.
      </p>
    </div>
  );
}
